export default __webpack_public_path__ + "static/media/nr4.2a6b9d83.svg";